/** Must match consumer-components `add-to-cart-event.ts`. */
export const PC_ADD_TO_CART_EVENT = "pc:add-to-cart" as const;

/** Surface an add-to-cart originated from. Drives future analytics. */
export type AddToCartSource =
	| "pdp"
	| "plp"
	| "pdp-recommended"
	| "atc-recommended"
	| "cart-recommended"
	| "recently-viewed";

export type AddToCartEventDetail = {
	productCode: string;
	quantity: string;
	purchaseType: "oneTime" | "monthly";
	// Mandatory: every add-to-cart must declare its originating surface.
	source: AddToCartSource;
	// Image shown on the originating surface — used only as a fallback when
	// the product catalog returns no image.
	imageUrl?: string;
	requestId?: string;
};

export const PC_ADD_TO_CART_RESULT_EVENT = "pc:add-to-cart:result" as const;

export type AddToCartResultDetail = {
	requestId: string;
	status: "success" | "error";
};

export function isAddToCartEventDetail(
	value: unknown
): value is AddToCartEventDetail {
	if (value == null || typeof value !== "object") return false;
	const o = value as Record<string, unknown>;
	return (
		typeof o.productCode === "string" &&
		typeof o.quantity === "string" &&
		(o.purchaseType === "oneTime" || o.purchaseType === "monthly") &&
		typeof o.source === "string" &&
		(o.imageUrl === undefined || typeof o.imageUrl === "string") &&
		(o.requestId === undefined || typeof o.requestId === "string")
	);
}
